import type Phaser from "phaser";

/** Scale image uniformly so it fits inside maxW × maxH (letterbox inside footprint). */
export function fitImageContainInFootprint(
  img: Phaser.GameObjects.Image,
  maxW: number,
  maxH: number,
  originX = 0.5,
  originY = 1,
  extraScale = 1,
): void {
  img.setOrigin(originX, originY);
  const tw = img.width;
  const th = img.height;
  if (tw <= 0 || th <= 0) return;
  const scale = Math.min(maxW / tw, maxH / th) * extraScale;
  img.setScale(scale);
}

/** Scale image uniformly to cover maxW × maxH (may crop visually; good for backdrops). */
export function fitImageCoverInBox(
  img: Phaser.GameObjects.Image,
  maxW: number,
  maxH: number,
  originX = 0.5,
  originY = 0.5,
): void {
  img.setOrigin(originX, originY);
  const tw = img.width;
  const th = img.height;
  if (tw <= 0 || th <= 0) return;
  const scale = Math.max(maxW / tw, maxH / th);
  img.setScale(scale);
}
